<template>
	<div id="account">
		<div class="logo_nav">
			<!--logo-->
			<div class="logo">
				<img src="../../../static/logo/logo.png" class="logo_img">
			</div>
			<!--nav-->
			<div class="nav">
				<ul>
					<li v-for="item in nav">
						<router-link :to="item.Url" class="homeNav">
						{{item.name}}
						</router-link>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
export default {
  name: 'account',
  data () {
    return {
		nav:[
			{name:'网站首页',Url:'/'},
			{name:'关于纯晶',Url:'/gycj'},
			{name:'业务介绍',Url:'/swyszqb'},
			{name:'新闻中心',Url:'/xwzxhome'},
			{name:'成功案例',Url:'/cgal'},
			{name:'联系我们',Url:'/lxwm'},
//			{name:'个人简介',Url:'/grjj'},
			{name:'留言板',Url:'/lyb'}
		]     
    }
  }
}	
</script>

<style scoped>
	*{
		color:#333;
	}
	#account{
		width:100%;
		height:116px;
		position:fixed;
		top:0;
		left: 0;
		box-shadow: 0px 4px 14px #666;
		z-index: 600;
		background-color: #fefefe;
		line-height:116px;
		opacity: 0.95;
	}
	.logo_nav{
		width:1200px;
		height: 60px;
		margin:0 auto;
		position:relative;
	}
	.logo_img{
		margin-top:15px;
		line-height: 116px;
	}
	.logo{
		float: left;
	}
	.nav{
		float: left;
		position:absolute;
		right: 0;
	}
	.nav ul li{
		list-style: none;
		display: inline;
		color:#fff;
		font-size:14px;
		padding-right:30px;
		color:#333;	
	}
	.homeNav{
		font-size: 18px;
	}
</style>


// WEBPACK FOOTER //
// src/components/subcomponents/account.vue